/* 🤖 this file was generated by svg-to-ts */
export const matIconDoorbell: {
  name: 'doorbell';
  data: string;
} = {
  name: 'doorbell',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 16.5h2c0 .55-.45 1-1 1s-1-.45-1-1zm4-1.5v-2.34c0-1.54-.81-2.82-2.25-3.16v-.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.25C9.82 9.84 9 11.12 9 12.66V15H8v1h8v-1h-1zm-3-9.5L6 10v9h12v-9l-6-4.5M12 3l8 6v12H4V9l8-6z"/></svg>`
};
